import React, { useEffect, useState,Fragment, useReducer } from 'react'
import { Button, Row, Col, Container, Form, FormControl, InputGroup} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import buscarReducer, { initialStateDisabled } from './storeBuscar/buscar-reducers'
import { INIT, RESET, SET_DIAS, SET_DISABLED, SET_TIPO_GESTION } from './storeBuscar/types'
import {useFormik} from 'formik'
import { restarMeses, validaNumeros } from '../../common/Formatos'
import { Auth, LoadingComponent } from 'recupero-comunes'
import { limpiarCasos, obtenerConsultaCasos } from '../../store/actions/are-busqueda-casos-action'
import { validationSchemas } from '../../common/validation-Schemas-area-busqueda'
import { useLocation, useNavigate } from 'react-router-dom'

const hoy = () => {
  const fecha = new Date()
  const hoy = fecha.toISOString().split('T')[0]
  return hoy
}

const resetValues={idcaso:'',patente:'',siniestro:''}
const BuscarCasos = () => {  
  const history = useNavigate()
  const [loading, setLoading]=useState(false)
  const [myValues, setMyValues]=useState(resetValues)
  const [noFechas, setNoFechas]=useState(true)

  const [selected, setSelected]=useState('')
  const [dias, setDias]=useState('')
  
  const [isDias, setIsDias]=useState(false)
  
  const [isFechas, setIsfechas]=useState(true)
  const {rutUsuario, rutOrganizacion}=Auth.currentUser()
  const data_areaBuscar = useSelector((state) => state.areaBusquedaCasosReducer)
  const {cfg_form32, fechas,comboTipoGestion, comboEstado,comboSituacion,comboTipoFecha,consultaCasos} = data_areaBuscar
  
  const [stateBuscar, dispatchBuscar]=useReducer(buscarReducer, initialStateDisabled)
  const dispatch = useDispatch()
  const { state } = useLocation()
  let querState =state?.queryState && state?.queryState
  
  const handleRadio=(e)=>{
    setSelected(e.target.id)

    if(e.target.id==='tipogestion'){
      
      dispatchBuscar({type:RESET})
      dispatchBuscar({type:SET_TIPO_GESTION, payload:{disabled:true, name:e.target.id}})
    } else{

      dispatchBuscar({type:RESET})
      dispatchBuscar({type:SET_DISABLED, payload:{disabled:true, name:e.target.id}})
    }
      setMyValues(resetValues)
      setIsfechas(false)  
      setIsDias(false)
  }

  const handleLimpliar=()=>{
    setSelected('')
    setIsfechas(true)
    dispatchBuscar({type:INIT})
    dispatch(limpiarCasos())
    setMyValues(resetValues)
   querState=null
    
      setIsDias(false)
      if(fechas){
        setMyValues({...resetValues, fechahasta:hoy(), fechadesde:restarMeses(parseInt(fechas.fechas['valorParametro']))})
        }
  }
  useEffect(()=>{
    dispatchBuscar({type:INIT})

  },[])

  useEffect(()=>{   
    if( querState){
      let resultado={}
      let valores = Object.values(querState); 
      let myKeys = Object.keys(querState); 
      for(let i=0; i< valores.length; i++){
        if(valores[i]!=='' && myKeys[i]!=='rutcia' && myKeys[i]!=='rutusr' ){
          if(myKeys[i]==='audienciapendiente'){
            setIsDias(valores[i])
            
          }else{
            resultado[myKeys[i]]=valores[i]
          }
          
        }
      }      
      let valoresR = Object.values(resultado); 
      let myKeysR = Object.keys(resultado); 
      let filter={...resetValues}
      for(let i=0; i< valoresR.length; i++){
        
        if(Object.entries(resultado).length===1 && myKeysR[i]!=='tipogestion'){
              setNoFechas(false)
              dispatchBuscar({type:RESET})
              dispatchBuscar({type:SET_DISABLED, payload:{disabled:true, name:myKeysR[i]}})
              setMyValues({...resetValues,[myKeysR[i]]:valoresR[i], fechadesde:''})
        }else{
          if(myKeysR[i]==='tipogestion'){
            setNoFechas(false)
            dispatchBuscar({type:RESET})
            dispatchBuscar({type:SET_TIPO_GESTION, payload:{disabled:true, name:myKeysR[i]}})
            for(let j=0; j< Object.entries(resultado).length; j++){
              filter[myKeysR[j]]=valoresR[j]
            }
            setMyValues(filter)
          
          }else{
            setNoFechas(false)
            for(let j=0; j< Object.entries(resultado).length; j++){
              filter[myKeysR[j]]=valoresR[j]
            }
            setMyValues(filter)
          }
        }      
      }
      querState['rutcia'] = rutOrganizacion && rutOrganizacion
      querState['rutusr'] =rutUsuario && rutUsuario
      let query1 = Buffer.from(JSON.stringify(querState)).toString('base64')
      dispatch(obtenerConsultaCasos(query1))
     
    }
 
  setIsfechas(false)
    querState = null
    history('/area-gestion-casos')
  },[state])
 
  const formik = useFormik({
    initialValues: {
      "rutcia": '',
      "rutusr":'',
      "idcaso": '',
      "siniestro":'',
      "patente": '',
      "tipogestion": '207002',     
    },
    validationSchema: validationSchemas(isFechas, isDias, selected),
    onSubmit: (formData) => {
      setLoading(true)
        const dataForm = {
            ...formData
        }

        dataForm['rutcia'] = rutOrganizacion && rutOrganizacion
        dataForm['rutusr'] =rutUsuario && rutUsuario             
       let query = Buffer.from(JSON.stringify(dataForm)).toString('base64')
       dispatch(limpiarCasos())            
      dispatch(obtenerConsultaCasos(query)) 
      .then(()=>setLoading(false))
      localStorage.setItem('filtrosAreaGestionCasos',JSON.stringify(dataForm))
      
      
    }
})
useEffect(()=>{
  //console.log(consultaCasos && consultaCasos, "respuesta casos")
},[consultaCasos])
  return (
    <>
 <style type='text/css'>
        {`
    .btn-limpiar {
      background-color: #F0AD3E;
      color: #FFFFFF;
      width: 140px;
      
    }
    .btn-carpeta:hover{
        background-color:#e1b97f;
        color: #FFFFFF;

    }
    .btn-buscar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-actualizar:hover{
        background-color:  #F6897E;
      color: #FFFFFF;
    }
    
    `}
    </style>
      <LoadingComponent show={loading}/>
      <Form onSubmit={formik.handleSubmit}>
          <Container>
            <Container>            
              {cfg_form32? (
                <div >                  
                  <Row >                 
                    <Col>
                      <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {cfg_form32.cfg_form32['consultacasos-filtro-siniestro']}
                      </Form.Label>{' '}
                      <br />
                      <InputGroup>
                        <InputGroup.Radio aria-label="Radio button for following text input" name='select' id='siniestro' onChange={e=>handleRadio(e)} checked={stateBuscar.siniestro.disabled}/>
                        <FormControl aria-label="Text input with radio button" disabled={!stateBuscar.siniestro.disabled}
                          onChange={(e)=>{
                            formik.handleChange(e)                                                    
                            setMyValues({...myValues,siniestro:e.target.value})
                          }}
                          value={formik.values.siniestro=myValues.siniestro}
                          name='siniestro'
                          error={formik.values.error}
                        />
                    </InputGroup>
                    {formik.errors.siniestro ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.siniestro}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                    </Col>
                    <Col >
                      <Form.Label
                        className='mb-2 mt-4'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {
                          cfg_form32.cfg_form32[
                            'consultacasos-filtro-patente'
                          ]
                        }
                      </Form.Label>{' '}
                      <br />
                      <InputGroup>
                        <InputGroup.Radio aria-label="Radio button for following text input" name='select'
                             id='patente' checked={stateBuscar.patente.disabled}
                             onChange={e=>handleRadio(e)} />
                        <FormControl aria-label="Text input with radio button"  disabled={!stateBuscar.patente.disabled}
                            onChange={(e)=>{
                              formik.handleChange(e)
                              setMyValues({...myValues,patente:e.target.value})
                              
                            }}
                            value={formik.values.patente=myValues.patente}
                            name='patente'
                            error={formik.values.error}
                        />
                        
                          
                    </InputGroup>
                    {formik.errors.patente ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.patente}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                    </Col>
                    <Col >
                      <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {cfg_form32.cfg_form32['consultacasos-filtro-idcaso']}
                      </Form.Label>{' '}
                      <br />
                      <InputGroup>
                        <InputGroup.Radio aria-label="Radio button for following text input"
                         name='select' id='idcaso' 
                         checked={stateBuscar.idcaso.disabled}
                         onChange={e=>handleRadio(e)}/>
                        <FormControl aria-label="Text input with radio button" disabled={!stateBuscar.idcaso.disabled}
                          onKeyDown={validaNumeros}
                          onChange={(e)=>{
                            formik.handleChange(e)
                            
                            setMyValues({...myValues, idcaso: e.target.value})
                          }}
                          value={formik.values.idcaso=myValues.idcaso}
                          name='idcaso'
                          error={formik.values.error}
                      
                        />
                    </InputGroup>
                    {formik.errors.idcaso ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.idcaso}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                    </Col>                                     
                  </Row>                                                   
                <hr style={{ color: '#04005D', height: '2px', marginTop:'30px' }}></hr>                
               <Row className='mt-2'>
                        
                  <Col className='d-flex align-items-end justify-content-end m-2'>
                      <Button className='m-2' variant='limpiar' onClick={handleLimpliar}  >
                        {cfg_form32 && cfg_form32.cfg_form32["consultacasos-boton-limpiar"]}
                      </Button>
                      <Button className='m-2' variant='buscar' type='onSubmit' >
                        {cfg_form32 && cfg_form32.cfg_form32["consultacasos-boton-buscar"]}
                      </Button>                                                                      
                    </Col>
                </Row>
                </div>
              ) : null}
            </Container>                    
          </Container>       
     </Form>    
    </>
  )
}
export default BuscarCasos
